import React, { Fragment } from "react";
import {
  Row, Col, Card, CardBody, CardTitle, Label, Button
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import LanguageHelper from '../Helpers/LanguageHelper'
import { IncidentContext } from "./IncidentContext";

class ThreatHighlights extends React.Component {

  static contextType = IncidentContext;

  render() {
    const { t, i18n } = this.props;

    const { loaded, originalClassification, userClassification,
      message, threats, origin, campaign } = this.context;

    const classificationClass = (classification) => {
      switch (classification) {
        case 'Phishing':
        case 'Spam':
        case 'Malware':
          return 'fg-classification bg-ev-phishing';
        case 'Warning':
          return 'fg-classification bg-ev-warning';
        case 'Legitimate':
          return 'fg-classification bg-ev-legitimate';
        default:
          return '';
      }
    }

    const action = (action, label, color) => {
      return (
        <Button color={color} className="mr-1" disabled={!loaded}
          onClick={() => this.context.closeIncident(action)}>
          {label}
        </Button>
      );
    }

    // const showActions = (originalClassification === 'Phishing' || originalClassification === 'phishing') ?
    //   <Fragment>
    //     {action("false positive", t("incidents.actions.false_positive"), "primary")}
    //     {action("legitimate", t("incidents.actions.legitimate"), "primary")}
    //   </Fragment>
    //   :
    const showActions = <Fragment>
        {action("phishing", t("incidents.actions.phishing"), "danger")}
        {action("spam", t("incidents.actions.spam"), "warning")}
        {action("legitimate", t("incidents.actions.legitimate"), "primary")}
        {action("ignore", t("incidents.actions.ignore"), "primary")}
      </Fragment>;

    const threatList = threats && threats.length > 0 ? threats.map((t, i) => <li key={`threat_${i}`}>{t}</li>) : "";
    const language = message.language ? LanguageHelper.getLanguage(message.language) : "";
    const originAddress = origin && (origin.city || origin.country) ? `${origin.city} (${origin.country})` : "";

    return (
      <Fragment>
        <Card className="main-card mb-3">
          <CardBody>
            <CardTitle>{t("incidents.threat_highlights")}</CardTitle>
            <Row form>
              <Col md={12}>
                <Label className="mr-sm-2">{t("incidents.classification")}:</Label>
                <Label>{originalClassification}</Label>
              </Col>
              <Col md={12}>
                <ul className="custom-list">
                  {threatList}
                </ul>
              </Col>
              <Col md={12} className={classificationClass(userClassification)}>
                <Label className="mr-sm-2">{t("incidents.user_classification")}:</Label>
                <Label>{userClassification}</Label>
              </Col>
              <Col md={12}>
                {showActions}
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card className="main-card mb-3">
          <CardBody>
            <CardTitle>{t("incidents.key_characteristics")}</CardTitle>
            <Row form>
              <Col md={12}>
                <Label className="mr-sm-2">{t("incidents.message_origin")}:</Label>
                <Label>{originAddress}</Label>
              </Col>
              <Col md={12}>
                <Label className="mr-sm-2">{t("incidents.message_language")}:</Label>
                <Label>{language}</Label>
              </Col>
              <Col md={12}>
                <Label className="mr-sm-2">{t("incidents.message_agent")}:</Label>
                <Label>{message.userAgent}</Label>
              </Col>
              <Col md={12}>
                <Label className="mr-sm-2">{t("incidents.campaign_name")}:</Label>
                <Label>{campaign.name}</Label>
                <Label>{campaign.id}</Label>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Fragment >
    )
  }
}

export default withTranslation()(ThreatHighlights);
